import { Link } from "react-router-dom";
import { useContent } from "../context/ContentContext";

const PageShell = ({ title, children }) => {
  const { content } = useContent();
  return (
    <div className="min-h-screen bg-sage-50 text-sage-800">
      <header className="bg-white border-b border-sage-200">
        <div className="container mx-auto px-6 md:px-12 py-6 flex items-center justify-between">
          <Link to="/" className="font-script text-2xl text-sage-700">
            {content.hero_names || "Nico & Nicole"}
          </Link>
          <Link
            to="/"
            className="text-sm uppercase tracking-[0.2em] text-sage-600 hover:text-sage-800"
          >
            ← Zur Hochzeitsseite
          </Link>
        </div>
      </header>
      <main className="container mx-auto px-6 md:px-12 py-16 max-w-3xl">
        <h1 className="font-serif text-4xl md:text-5xl text-sage-800 mb-10">
          {title}
        </h1>
        <div className="prose-content space-y-6 text-sage-700 text-base leading-relaxed">
          {children}
        </div>
      </main>
      <footer className="border-t border-sage-200 bg-white py-8 mt-12">
        <div className="container mx-auto px-6 md:px-12 flex flex-wrap items-center justify-between gap-4 text-xs text-sage-500">
          <span>© 2026 · Nico Haage</span>
          <div className="flex gap-4">
            <Link to="/impressum" className="hover:text-sage-700">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-sage-700">Datenschutz</Link>
            <Link to="/agb" className="hover:text-sage-700">AGB</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export const Impressum = () => (
  <PageShell title="Impressum">
    <h2 className="font-serif text-2xl text-sage-800">Angaben gemäß § 5 TMG</h2>
    <p>
      <strong>Nico Haage</strong><br />
      Karl-Marx-Straße 21<br />
      04746 Hartha<br />
      Deutschland
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">Kontakt</h2>
    <p>
      E-Mail: <a className="text-sage-600 underline" href="mailto:Buero@nhaage.de">Buero@nhaage.de</a>
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">
      Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
    </h2>
    <p>
      Nico Haage<br />
      Karl-Marx-Straße 21<br />
      04746 Hartha
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">Haftung für Inhalte</h2>
    <p>
      Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für
      die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir
      jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7
      Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
      Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
      jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
      Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
      rechtswidrige Tätigkeit hinweisen.
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">Haftung für Links</h2>
    <p>
      Unser Angebot enthält Links zu externen Websites Dritter, auf deren
      Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
      Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
      Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
      verantwortlich.
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">Urheberrecht</h2>
    <p>
      Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
      Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
      Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen
      des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
      Autors bzw. Erstellers.
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">
      Online-Streitbeilegung
    </h2>
    <p>
      Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung
      (OS) bereit:{" "}
      <a
        className="text-sage-600 underline"
        href="https://ec.europa.eu/consumers/odr"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://ec.europa.eu/consumers/odr
      </a>
      . Wir sind nicht bereit oder verpflichtet, an einem Streitbeilegungs-
      verfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
    </p>
  </PageShell>
);

export const Datenschutz = () => (
  <PageShell title="Datenschutzerklärung">
    <h2 className="font-serif text-2xl text-sage-800">1. Verantwortlicher</h2>
    <p>
      Verantwortlicher für die Datenverarbeitung auf dieser Website ist:<br />
      Nico Haage, Karl-Marx-Straße 21, 04746 Hartha,
      E-Mail: <a className="text-sage-600 underline" href="mailto:Buero@nhaage.de">Buero@nhaage.de</a>
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">
      2. Welche Daten erheben wir?
    </h2>
    <p>
      Wir erheben personenbezogene Daten, die du uns aktiv über das
      RSVP-Formular oder den Foto-Upload zur Verfügung stellst:
    </p>
    <ul className="list-disc pl-6 space-y-1">
      <li>
        <strong>Zusage-Formular:</strong> Name, E-Mail-Adresse (optional),
        Anzahl Begleitpersonen, Ernährungswünsche, Wunsch nach Übernachtung,
        Nachricht.
      </li>
      <li>
        <strong>Foto-Upload:</strong> Hochgeladene Bilder sowie ein optional
        angegebener Vorname.
      </li>
      <li>
        <strong>Server-Logs:</strong> Beim Aufruf der Seite werden technisch
        notwendige Daten (IP-Adresse, Browser, Datum/Uhrzeit) kurzzeitig
        verarbeitet, um die Auslieferung der Seite zu ermöglichen.
      </li>
    </ul>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">3. Zweck</h2>
    <p>
      Die Daten werden ausschließlich zur Organisation unserer Hochzeit am
      01.08.2026 (Gästeplanung, Sitzordnung, Catering, Gestaltung der
      Foto-Erinnerungen) verwendet.
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">
      4. Rechtsgrundlage
    </h2>
    <p>
      Die Verarbeitung erfolgt auf Grundlage deiner Einwilligung gemäß
      Art. 6 Abs. 1 lit. a DSGVO durch das aktive Absenden des Formulars bzw.
      des Foto-Uploads. Du kannst deine Einwilligung jederzeit per E-Mail an
      <a className="text-sage-600 underline" href="mailto:Buero@nhaage.de"> Buero@nhaage.de</a> widerrufen.
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">5. Speicherort</h2>
    <ul className="list-disc pl-6 space-y-1">
      <li>RSVP-Daten: Datenbank des Web-Hosters (innerhalb der EU).</li>
      <li>
        E-Mail-Versand: Resend (USA, EU-Standardvertragsklauseln) — sofern
        aktiviert.
      </li>
      <li>
        Hochgeladene Fotos: Private Nextcloud-Instanz unter cloud.nhaage.de
        (Server in Deutschland).
      </li>
    </ul>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">
      6. Cookies & Speicher
    </h2>
    <p>
      Diese Website verwendet <strong>keine Tracking- oder Werbe-Cookies</strong>.
      Wir nutzen ausschließlich technisch notwendigen Speicher
      (<em>Session Storage</em>) zur Speicherung des Admin-Login-Zustands.
      Diese Daten werden beim Schließen des Browsers automatisch gelöscht.
    </p>
    <p>
      Es findet keine Analyse mit Google Analytics, Facebook Pixel oder
      vergleichbaren Diensten statt.
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">
      7. Speicherdauer
    </h2>
    <p>
      RSVP-Daten werden bis spätestens 6 Monate nach der Hochzeit (also bis
      31.01.2027) gelöscht. Hochgeladene Fotos verbleiben auf Wunsch des
      Brautpaars als persönliche Erinnerung in der privaten Nextcloud.
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">
      8. Deine Rechte
    </h2>
    <p>
      Du hast jederzeit das Recht auf:
    </p>
    <ul className="list-disc pl-6 space-y-1">
      <li>Auskunft über deine gespeicherten Daten (Art. 15 DSGVO)</li>
      <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
      <li>Löschung deiner Daten (Art. 17 DSGVO)</li>
      <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
      <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
      <li>Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)</li>
      <li>
        Beschwerde bei der zuständigen Aufsichtsbehörde — in Sachsen:
        Sächsischer Datenschutzbeauftragter, Devrientstraße 5, 01067 Dresden.
      </li>
    </ul>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">9. Kontakt</h2>
    <p>
      Anfragen zum Datenschutz bitte an{" "}
      <a className="text-sage-600 underline" href="mailto:Buero@nhaage.de">Buero@nhaage.de</a>.
    </p>
  </PageShell>
);

export const AGB = () => (
  <PageShell title="Nutzungsbedingungen">
    <p className="text-sm text-sage-500 italic">
      Diese Hochzeitswebsite ist ein <strong>privates, nicht-kommerzielles
      Angebot</strong>. Die folgenden Bedingungen gelten für die Nutzung der
      Funktionen Zusage-Formular und Foto-Upload.
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">1. Geltungsbereich</h2>
    <p>
      Diese Bedingungen gelten für alle Besucher und Gäste, die die Funktionen
      dieser Website nutzen. Mit der Nutzung erkennst du diese Bedingungen an.
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">
      2. RSVP-Funktion
    </h2>
    <p>
      Mit dem Absenden des RSVP-Formulars versicherst du, dass die angegebenen
      Daten wahrheitsgemäß und mit der Zustimmung der genannten Begleitpersonen
      angegeben werden. Die Zusage ist eine private Mitteilung an das Brautpaar.
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">
      3. Foto-Upload
    </h2>
    <p>
      Beim Upload eines Fotos bestätigst du:
    </p>
    <ul className="list-disc pl-6 space-y-1">
      <li>
        Du bist Urheber des Fotos oder hast die Rechte zur Veröffentlichung.
      </li>
      <li>
        Alle abgebildeten Personen haben in die Veröffentlichung eingewilligt.
      </li>
      <li>
        Das Bild verstößt nicht gegen geltendes Recht und enthält keine
        beleidigenden, gewaltverherrlichenden, pornografischen oder
        diskriminierenden Inhalte.
      </li>
      <li>
        Du räumst dem Brautpaar das nicht-exklusive Recht zur privaten Nutzung,
        Speicherung und Anzeige des Bildes auf dieser Website und in privaten
        Erinnerungs-Alben ein.
      </li>
    </ul>
    <p>
      Das Brautpaar behält sich das Recht vor, ungeeignete Inhalte ohne Angabe
      von Gründen zu entfernen.
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">
      4. Haftung
    </h2>
    <p>
      Die Website wird in der jeweils aktuellen Form ohne Gewähr zur Verfügung
      gestellt. Eine Haftung für Datenverlust, technische Ausfälle oder
      missbräuchliche Nutzung durch Dritte ist — soweit gesetzlich zulässig —
      ausgeschlossen.
    </p>

    <h2 className="font-serif text-2xl text-sage-800 pt-4">
      5. Schlussbestimmungen
    </h2>
    <p>
      Es gilt deutsches Recht. Sollten einzelne Bestimmungen unwirksam sein,
      bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
    </p>

    <p className="pt-6 text-sm text-sage-500">
      Stand: 28.04.2026 · Nico Haage, Hartha
    </p>
  </PageShell>
);
